import { useEffect } from "react";
import { useAppStore } from "../store/useAppStore";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "../constants";

function detectBrowserLang() {
  const raw =
    navigator.language?.slice(0, 2) ||
    navigator.languages?.[0]?.slice(0, 2) ||
    DEFAULT_LANG;

  return SUPPORTED_LANGS.includes(raw) ? raw : DEFAULT_LANG;
}

export function useLanguageDetection() {
  const { appLang, setAppLang } = useAppStore();

  useEffect(() => {
    const stored = localStorage.getItem("app_lang");

    if (stored && SUPPORTED_LANGS.includes(stored)) {
      setAppLang(stored);
      return;
    }

    const detected = detectBrowserLang();
    localStorage.setItem("app_lang", detected);
    setAppLang(detected);
  }, [setAppLang]);

  return appLang;
}
